import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { username, password });
      localStorage.setItem("duo_admin_token", data.token);
      localStorage.setItem("duo_admin_user", JSON.stringify(data.admin));
      toast.success("Bem-vinda, administradora");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Credenciais inválidas");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F5EF] px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white border border-[#C2A064]/20 p-10">
        <div className="text-center">
          <div className="font-display text-3xl text-[#49392F]">Duo <span className="italic text-[#C2A064]">Áurea</span></div>
          <p className="text-[11px] tracking-[0.3em] uppercase text-[#C2A064] mt-3">Painel administrativo</p>
        </div>
        <form onSubmit={submit} className="mt-10 space-y-4">
          <input required placeholder="Usuário" className="duo-input" value={username} onChange={(e) => setUsername(e.target.value)} data-testid="admin-username" />
          <input required type="password" placeholder="Senha" className="duo-input" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" />
          <button disabled={loading} className="duo-btn duo-btn-primary w-full" data-testid="admin-login-submit">
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
